import React, { memo } from 'react';

import { areEqual } from 'Utils/equalityChecks';
import { useGHL } from 'Context/GHL';

import classes from './ghlDashboard.module.css';

// GHL Dashboard - Project overview for GHL embedded views
function GHLDashboardContainer() {
  const { isAuthenticated, userName, locationId, locationName, role, error } = useGHL();

  if (error) {
    return (
      <div className={classes.container}>
        <div className={classes.errorCard}>
          <h2>Connection Error</h2>
          <p>{error}</p>
          <p className={classes.helpText}>
            Please ensure this page is accessed from within RocketCRM.
          </p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div className={classes.container}>
        <div className={classes.card}>
          <h2>Not Authenticated</h2>
          <p>Please access this page from within RocketCRM.</p>
        </div>
      </div>
    );
  }

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <h1>RocketPlan Dashboard</h1>
        <p className={classes.subtitle}>
          Welcome, {userName || 'User'}
          {role === 'admin' && <span className={classes.badge}>Admin</span>}
        </p>
      </div>

      <div className={classes.infoCard}>
        <h3>GHL Connection</h3>
        <div className={classes.infoGrid}>
          <div className={classes.infoItem}>
            <span className={classes.label}>Location ID:</span>
            <span className={classes.value}>{locationId || 'N/A'}</span>
          </div>
          {locationName && (
            <div className={classes.infoItem}>
              <span className={classes.label}>Location:</span>
              <span className={classes.value}>{locationName}</span>
            </div>
          )}
          <div className={classes.infoItem}>
            <span className={classes.label}>Status:</span>
            <span className={`${classes.value} ${classes.connected}`}>Connected</span>
          </div>
        </div>
      </div>

      <div className={classes.placeholderCard}>
        <h3>Projects</h3>
        <p>
          Project list will appear here once the GHL location is mapped to RocketPlan company.
        </p>
        <p className={classes.helpText}>
          Backend integration required to map GHL locationId to RocketPlan projects.
        </p>
      </div>
    </div>
  );
}

const GHLDashboardContainerMemo = memo(GHLDashboardContainer, areEqual);

export { GHLDashboardContainerMemo as GHLDashboardContainer };
